import { useEffect, useRef, memo } from "react";

/**
 * Embeds a TradingView Advanced Chart widget.
 * Free — no API key needed. Includes indicators, drawing tools, timeframes.
 */
function TradingViewChart({ symbol = "BITSTAMP:BTCUSD", height = 860, studies = ["STD;RSI", "STD;EMA"], hideVolume = false }) {
  const containerRef = useRef(null);

  useEffect(() => {
    const node = containerRef.current;
    if (!node) return;
    node.innerHTML = "";

    const wrapper = document.createElement("div");
    wrapper.className = "tradingview-widget-container__widget";
    wrapper.style.height = "100%";
    wrapper.style.width = "100%";
    node.appendChild(wrapper);

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js";
    script.async = true;
    script.innerHTML = JSON.stringify({
      width: "100%",
      height: height,
      symbol,
      interval: "D",
      timezone: "Etc/UTC",
      theme: "dark",
      style: "1",
      locale: "fr",
      backgroundColor: "#0A0A0A",
      gridColor: "rgba(255, 255, 255, 0.06)",
      hide_top_toolbar: false,
      hide_legend: false,
      hide_volume: hideVolume,
      allow_symbol_change: true,
      save_image: false,
      studies,
      support_host: "https://www.tradingview.com",
    });
    node.appendChild(script);

    return () => {
      if (node) node.innerHTML = "";
    };
  }, [symbol, height, hideVolume, JSON.stringify(studies)]);

  return (
    <div
      ref={containerRef}
      className="tradingview-widget-container rounded-lg overflow-hidden border border-white/5"
      style={{ height: `${height}px`, width: "100%" }}
      data-testid="tradingview-chart"
    />
  );
}

export default memo(TradingViewChart);
